module.exports = __webpack_public_path__ + "static/img/articlecrm1.53980f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlecrm1.jpg
// module id = TNbO
// module chunks = 1